"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const router_1 = require("next/router");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const libs_auth_next_1 = require("@hotelplan/libs.auth-next");
const libs_cross_login_1 = require("@hotelplan/libs.cross-login");
const libs_login_redirect_1 = require("@hotelplan/libs.login-redirect");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const LoginSocialWrapper = styled_components_1.default.div(({ theme }) => theme.auth.loginSocialWrapper);
const FacebookLoginButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    'data-id': `facebook-login`,
})(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign(Object.assign({}, theme.auth.loginSocialButton), { backgroundColor: 'facebookButtonBackground', '.icon': {
        backgroundColor: 'facebookIconBackground',
    } })));
const GoogleLoginButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    'data-id': `google-login`,
})(({ theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign(Object.assign({}, theme.auth.loginSocialButton), { backgroundColor: 'googleButtonBackground', '.icon': {
        backgroundColor: 'googleIconBackground',
    } })));
const LoginSocial = () => {
    const [t, { language }] = (0, next_i18next_1.useTranslation)('auth');
    const { query } = (0, router_1.useRouter)();
    const callbackUrlQueryParam = (0, libs_cross_login_1.getCallbackUrlQueryParamFromQuery)(query);
    const redirectUrlQueryParam = (0, libs_login_redirect_1.getRedirectQueryParamFromQuery)(query);
    function getSocialLoginHref(base) {
        let href = `${base}?lang=${language}`;
        if (callbackUrlQueryParam) {
            href += `&${callbackUrlQueryParam.name}=${callbackUrlQueryParam.value}`;
        }
        if (redirectUrlQueryParam) {
            href += `&${redirectUrlQueryParam.name}=${redirectUrlQueryParam.value}`;
        }
        return href;
    }
    function onFacebookLogin() {
        window.location.href = getSocialLoginHref(libs_auth_next_1.SSR_LOGIN_FACEBOOK_ENDPOINT_PATH);
    }
    function onGoogleLogin() {
        window.location.href = getSocialLoginHref(libs_auth_next_1.SSR_LOGIN_GOOGLE_ENDPOINT_PATH);
    }
    return (react_1.default.createElement(LoginSocialWrapper, null,
        react_1.default.createElement(FacebookLoginButton, { className: "facebook-login-button", onClick: onFacebookLogin },
            react_1.default.createElement(components_common_icon_1.Icon, { name: "facebook-mono", className: "login-social-icon" }),
            react_1.default.createElement("span", { className: "login-social-text" }, t('auth:facebook.button'))),
        react_1.default.createElement(GoogleLoginButton, { className: "google-login-button", onClick: onGoogleLogin },
            react_1.default.createElement(components_common_icon_1.Icon, { name: "google-mono", className: "login-social-icon" }),
            react_1.default.createElement("span", { className: "login-social-text" }, t('auth:google.button')))));
};
exports.default = LoginSocial;
//# sourceMappingURL=LoginSocial.js.map